<div class="dialog-title-container">
  <mat-icon class="title-icon">add_location_alt</mat-icon>
  <h2 mat-dialog-title>Create New Geofence</h2>
</div>

<mat-dialog-content>
  <form [formGroup]="geofenceForm" class="form-container">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter geofence name" />
      @if (geofenceForm.get('name')?.hasError('required')) {
      <mat-error> Name is required </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description" placeholder="Enter description (optional)" rows="3"> </textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="geofenceForm.invalid">Save</button>
</mat-dialog-actions>
